//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ServicesBaseClass {
    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        options.credentials = 'include';

        return Promise.resolve(options);
    }
}

export class AppointmentBookingClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(bookingId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentbookings/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    create(model?: AppointmentBookingCreateUpdateModel | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentbookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    checkIn(bookingId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentbookings/{bookingId}/CheckIn";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIn(_response);
        });
    }

    protected processCheckIn(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    attachment(): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentbookings/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class AppointmentCancellationClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    create(model?: AppointmentCancellationCreateModel | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentcancellations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class AppointmentDropInClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getPosition(dropInId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentdropins/{dropInId}/position";
        if (dropInId === undefined || dropInId === null)
            throw new Error("The parameter 'dropInId' must be defined.");
        url_ = url_.replace("{dropInId}", encodeURIComponent("" + dropInId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosition(_response);
        });
    }

    protected processGetPosition(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    create(model?: AppointmentDropInCreateModel | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentdropins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    delete(dropInId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/appointmentdropins/{dropInId}";
        if (dropInId === undefined || dropInId === null)
            throw new Error("The parameter 'dropInId' must be defined.");
        url_ = url_.replace("{dropInId}", encodeURIComponent("" + dropInId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class ConfigurationClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class DataExportsClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * [DISABLED]
     * @param model (optional) 
     * @return OK
     */
    run(id: number, model?: DataExportsRunPostRequest | null | undefined): Promise<ServiceResponse<FileResponse>> {
        let url_ = this.baseUrl + "/students/services/me/data-exports/run/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: Response): Promise<ServiceResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new ServiceResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<FileResponse>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * [DISABLED]
     * @param jobSeekerId (optional) 
     * @return OK
     */
    get(id: number, jobSeekerId?: number | null | undefined): Promise<ServiceResponse<DataResponseOfDataExportsReadModel>> {
        let url_ = this.baseUrl + "/students/services/me/data-exports/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (jobSeekerId !== undefined && jobSeekerId !== null)
            url_ += "jobSeekerId=" + encodeURIComponent("" + jobSeekerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<DataResponseOfDataExportsReadModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataResponseOfDataExportsReadModel;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<DataResponseOfDataExportsReadModel>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * [DISABLED]
     * @param page (optional) 
     * @param from (optional) 
     * @param until (optional) 
     * @param groupBy (optional) 
     * @param jobSeekerId (optional) 
     * @return OK
     */
    getItemsPagedList(id: number, dataSourceId: number, page?: number | null | undefined, from?: string | null | undefined, until?: string | null | undefined, groupBy?: string | null | undefined, jobSeekerId?: number | null | undefined): Promise<ServiceResponse<DataResponseOfApiPagedListOfIPagedListItem>> {
        let url_ = this.baseUrl + "/students/services/me/data-exports/{id}/data-sources/{dataSourceId}/page?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent("" + until) + "&";
        if (groupBy !== undefined && groupBy !== null)
            url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
        if (jobSeekerId !== undefined && jobSeekerId !== null)
            url_ += "jobSeekerId=" + encodeURIComponent("" + jobSeekerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemsPagedList(_response);
        });
    }

    protected processGetItemsPagedList(response: Response): Promise<ServiceResponse<DataResponseOfApiPagedListOfIPagedListItem>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataResponseOfApiPagedListOfIPagedListItem;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<DataResponseOfApiPagedListOfIPagedListItem>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class EventSessionsClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(sessionId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/eventsessions/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    book(sessionId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/eventsessions/{sessionId}/Book";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBook(_response);
        });
    }

    protected processBook(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    cancel(sessionId: number, model?: CancelBookingPostBody | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/eventsessions/{sessionId}/Cancel";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class EventWaitingListClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    join(eventId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/events/{eventId}/waitinglist/Join";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processJoin(_response);
        });
    }

    protected processJoin(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    leave(eventId: number): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/events/{eventId}/waitinglist/Leave";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeave(_response);
        });
    }

    protected processLeave(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class NotificationsClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    subscribe(model?: PushSubscriptionModel | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/notifications/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param model (optional) 
     * @return OK
     */
    markRead(type: NotificationType, id: number, model?: NotificationsMarkReadModel | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/notifications/markread/{type}/{id}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkRead(_response);
        });
    }

    protected processMarkRead(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class SelfCheckInClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    get(token?: string | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/selfcheckin/{token}";
        if (token !== null && token !== undefined)
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        else
            url_ = url_.replace("/{token}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    eventSessionCheckIn(sessionId: number, token?: string | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/selfcheckin/{token}/EventSessionCheckIn/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (token !== null && token !== undefined)
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        else
            url_ = url_.replace("/{token}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEventSessionCheckIn(_response);
        });
    }

    protected processEventSessionCheckIn(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export class TokenClient extends ServicesBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    get(token?: string | null | undefined): Promise<ServiceResponse<PublicTokenResponse>> {
        let url_ = this.baseUrl + "/students/services/me/token/{token}";
        if (token !== null && token !== undefined)
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        else
            url_ = url_.replace("/{token}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceResponse<PublicTokenResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicTokenResponse;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<PublicTokenResponse>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param token (optional) 
     * @param model (optional) 
     * @return OK
     */
    checkIn(token?: string | null | undefined, model?: PublicCheckInRequest | null | undefined): Promise<ServiceResponse<DataResponseOfPublicCheckInResponse>> {
        let url_ = this.baseUrl + "/students/services/me/token/{token}/checkin";
        if (token !== null && token !== undefined)
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        else
            url_ = url_.replace("/{token}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIn(_response);
        });
    }

    protected processCheckIn(response: Response): Promise<ServiceResponse<DataResponseOfPublicCheckInResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataResponseOfPublicCheckInResponse;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorModelOfEventErrorCode;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<DataResponseOfPublicCheckInResponse>>(new ServiceResponse(status, _headers, null as any));
    }

    /**
     * @param token (optional) 
     * @param model (optional) 
     * @return OK
     */
    checkInUndo(token?: string | null | undefined, model?: PublicCheckInUndoRequest | null | undefined): Promise<ServiceResponse<any>> {
        let url_ = this.baseUrl + "/students/services/me/token/{token}/checkin/undo";
        if (token !== null && token !== undefined)
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        else
            url_ = url_.replace("/{token}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckInUndo(_response);
        });
    }

    protected processCheckInUndo(response: Response): Promise<ServiceResponse<any>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return new ServiceResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorModelOfEventErrorCode;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error - Please report", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResponse<any>>(new ServiceResponse(status, _headers, null as any));
    }
}

export interface AppointmentBookingCreateUpdateModel {
    appointmentId: number;
    bookingId?: number | undefined;
    formatId: number;
    topicIds: number[];
    comment?: string | undefined;
    phone?: string | undefined;
    jobSeekerContactValue?: string | undefined;
    attachments: UploadFile[];
}

export type MediaType = "Image" | "Audio" | "Html" | "Text" | "Other";

export interface UploadFile {
    id?: string | undefined;
    name?: string | undefined;
    rename?: string | undefined;
    contentType?: string | undefined;
    extension?: string | undefined;
    uploadKey?: string | undefined;
    readonly mediaType: MediaType;
    url?: string | undefined;
    size?: string | undefined;
    readonly isTemp: boolean;
}

export type CancellationReasonType = "NoLongerWishToAttend" | "HaveACalendarConflict" | "UnableToGetToTheLocation" | "UnwellAndCannotAttend" | "HaveFoundAnAlternative" | "HaveResolvedMyConcerns" | "HavingTechnicalIssues" | "PreferNotToGiveAReason" | "Other";

export interface AppointmentCancellationCreateModel {
    bookingId: number;
    token?: string | undefined;
    reasonType: CancellationReasonType;
    reasonDescription?: string | undefined;
}

export interface AppointmentDropInCreateModel {
    appointmentId: number;
    jobSeekerId: number;
    topicIds: number[];
}

export interface DataExportsRunPostRequest {
    parameters?: { [key: string]: { [key: string]: string; }; } | undefined;
    jobSeekerId?: number | undefined;
}

export interface DataResponseOfDataExportsReadModel {
    readonly data: DataExportsReadModel;
}

export interface DataExportsReadModel {
    id: number;
    name: string;
    description: string;
    dataSources: DataSourceReadModel[];
}

export interface UserFilterParametersReadModel {
    key: string;
}

export type DataExportsDataSourceType = "Ers" | "CareerHub";

export interface DataSourceReadModel {
    id: number;
    type: DataExportsDataSourceType;
    entityTypeName: string;
    userFilterParameters?: UserFilterParametersReadModel[] | undefined;
}

export interface DataResponseOfApiPagedListOfIPagedListItem {
    readonly data: ApiPagedListOfIPagedListItem;
}

export interface ApiPagedListOfIPagedListItem {
    items: IPagedListItem[];
    readonly options: IPagingOptions;
    readonly totalCount: number;
    readonly pageIndex: number;
    readonly pageSize: number;
    readonly totalPages: number;
    readonly hasPreviousPage: boolean;
    readonly hasNextPage: boolean;
}

export interface IPagedListItem {
    id?: number | undefined;
    entityId?: number | undefined;
    name?: string | undefined;
    summary?: string | undefined;
    children: IPagedListItem[];
}

export interface IPagingOptions {
}

export interface CancelBookingPostBody {
    reasonType: CancellationReasonType;
    reasonDescription?: string | undefined;
}

/** The PushSubscription.toJSON() model https://developer.mozilla.org/en-US/docs/Web/API/PushSubscription/toJSON */
export interface PushSubscriptionModel {
    endpoint?: string | undefined;
    /** A DOMHighResTimeStamp (https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp)
of the subscription expiration time associated with the push subscription,
if there is one, or null otherwise. */
    expirationTime?: number | undefined;
    keys?: PushSubscriptionKeys | undefined;
}

export interface PushSubscriptionKeys {
    /** An Elliptic curve Diffie–Hellman (https://en.wikipedia.org/wiki/Elliptic_curve_Diffie%E2%80%93Hellman)
public key on the P-256 curve (that is, the NIST secp256r1 elliptic curve).
The resulting key is an uncompressed point in ANSI X9.62 format. */
    p256DH?: string | undefined;
    /** An authentication secret, as described in Message Encryption for Web Push.
https://datatracker.ietf.org/doc/html/draft-ietf-webpush-encryption-08 */
    auth?: string | undefined;
}

export interface NotificationsMarkReadModel {
    endpoint?: string | undefined;
}

export type NotificationType = "Alert" | "Appointment" | "Ban" | "Event" | "Form" | "Job" | "Question" | "WorkflowStage" | "Experience";

export interface PublicTokenResponse {
    readonly data: PublicToken;
    readonly eventSession?: PublicEventSession | undefined;
    readonly settings: PublicCheckInSettings;
    readonly strings: { [key: string]: string; };
}

export interface PublicEventSession {
    id: number;
    eventId: number;
    eventTitle: string;
    start: string;
    end: string;
}

export interface PublicCheckInSettings {
    readonly event: PublicEventSettings;
}

export interface NullableOfCheckInEventId {
    eventId?: number | undefined;
    sessionId?: number | undefined;
    readonly checkInId?: string | undefined;
}

export interface NullableOfCheckInLocationId {
    offCampusEventId?: number | undefined;
    campusId?: number | undefined;
    buildingId?: number | undefined;
    locationId?: number | undefined;
    readonly checkInId?: string | undefined;
}

export interface PublicEventSettings {
    readonly checkInMinutes: number;
    readonly checkInAfterEventEndsMinutes: number;
}

export type CheckInTokenType = "ticket" | "event" | "location";

export interface PublicToken {
    readonly tokenId: string;
    readonly value: string;
    readonly type: CheckInTokenType;
    readonly checkInEventId?: NullableOfCheckInEventId | undefined;
    readonly checkInLocationId?: NullableOfCheckInLocationId | undefined;
}

export interface PublicCheckInRequest {
    value: string;
}

export interface DataResponseOfPublicCheckInResponse {
    readonly data: PublicCheckInResponse;
}

export interface PublicCheckInResponse {
    undoToken: string;
}

export type EventErrorCode = "AlreadyBooked" | "AlreadyWaiting" | "AttendanceMarked" | "Banned" | "BookingDisabled" | "BookingNotOpen" | "BookingClosed" | "BookingLimitReached" | "BookingNotAllowed" | "BookingHold" | "CancellationsClosed" | "CheckInNotOpen" | "CheckInForbidden" | "EventNotPublished" | "EventCancelled" | "EventNotStarted" | "NotWaiting" | "NotBooked" | "BookingFormNotSubmitted" | "BookingFormSubmissionInDraft" | "BookingFormSubmissionPending" | "BookingFormSubmissionDeclined" | "JobSeekerNotFound";

export interface ErrorModelOfEventErrorCode {
    readonly code: EventErrorCode;
    readonly message: string;
    readonly data?: any | undefined;
    readonly stackTrace?: string | undefined;
}

export interface PublicCheckInUndoRequest {
    undoToken: string;
    value: string;
}

export class ServiceResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ServiceException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isServiceException = true;

    static isServiceException(obj: any): obj is ServiceException {
        return obj.isServiceException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ServiceException(message, status, response, headers, result);
}